<script setup lang='tsx'>
import { useAuthStore } from '@/store/modules/auth';
import { fetchGetUserTenantList, fetchPostChangeUserTenant, fetchPostTenantMenuList } from "@/service/api"
import { h, onMounted, ref } from 'vue'
import { type DropdownOption, NButton } from 'naive-ui';
import { localStg } from '@/utils/storage';
import { $t } from "@/locales"
const { getUserInfo, setSystemInfo, systemInfo } = useAuthStore();

const userInfo = getUserInfo()
const userTenantList = ref<any[]>([])


const handleDropdown = (key: string, option: DropdownOption) => {
  setSystemInfo({
    systemName: option.systemName,
    tenantId: option.clientId,
    logo: option.logo,
  })
  handleChangeTenant(key, option.clientId)
}

const handleChangeTenant = async (tenantId: string, clientId: string) => {
  const { data, error } = await fetchPostChangeUserTenant(tenantId)
  const { dataCenterId, menuIds, roleId, roleName, systemLogo, systemName, tenantUuid, userId } = data
  if (!error) {
    Object.assign(userInfo, {
      dataCenterId,
      menuIds,
      roleId,
      roleName,
      systemLogo,
      systemName,
      tenantUuid,
      userId,
      tenantId: clientId
    })

    localStg.set('personInfo', userInfo);
    window.location.href = '/'
    // window.location.reload()
    return

  }
}


const getUserTenantList = async () => {
  const { data, error } = await fetchGetUserTenantList()

  if (!error && Array.isArray(data)) {
    const itemToAdd = {
      type: 'divider',
      key: 'divider'
    }
    const newData = data.reduce((acc, current, index) => {
      acc.push(current);
      if (index < data.length - 1) {
        acc.push(itemToAdd);
      }
      return acc;
    }, []);
    userTenantList.value = newData
  }
}

const renderDropdownLabel = (option: DropdownOption) => {
  if (option.uuid === userInfo.tenantUuid) {
    return h(
      <div class={'color-primary'}>
        {option.systemName} ({$t('common.current')})
      </div>
    )
  }
  return h(
    <div>{option.systemName}</div>
  )
}

onMounted(() => {
  getUserTenantList()
})
</script>

<template>
  <NDropdown placement="bottom" :options="userTenantList" @select="handleDropdown" key-field="uuid"
    label-field="systemName" :render-label="renderDropdownLabel">
    <div>
      <NButton type="primary" class="text-16px text-white font-medium">
        {{ userInfo.systemName || systemInfo.systemName }}
        <icon-local-material-symbols-keyboard-arrow-down class="text-icon" />
      </NButton>
    </div>
  </NDropdown>
</template>

<style scoped lang='scss'></style>
